'use strict';

class AccountSettings {
  constructor($rootScope, $window, $location, originatorService, validationService, commonService, Notification) {
    this.originatorService = originatorService;
    this.validationService = validationService;
    this.commonService = commonService;
    this.Notification = Notification;
    this.$location = $location;
    this.$window = $window;
    this.$rootScope = $rootScope;
  }

  $onInit() {
    this.settings = {};
    this.currencies = [];
    this.commonService.getExchangeRates()
      .then((resp) => {
        this.currencies = resp;
      });

    this.load();
  }

  load() {
    this.originatorService.settings()
      .then((resp) => {
        this.settings = resp.data;
      });
  }

  save() {
    let clone = angular.copy(this.settings);

    if (clone.defaults.copy.email === '') {
      clone.defaults.copy.email = null;
    }

    if (clone.defaults.event.confirmationCopy === '') {
      clone.defaults.event.confirmationCopy = null;
    }

    if (clone.defaults.artTax.artTaxPercent === '') {
      clone.defaults.artTax.artTaxPercent = null;
    }

    this.originatorService.updateSettings(clone)
      .then(() => {
        this.load();
        this.Notification.success('Endringene for din SendRegning-konto er n&aring; lagret.');
        this.$rootScope.$broadcast('originatorSettingsUpdated');
      })
      .catch((err) => {
        if (err) {
          this.validationService.cleanupErrors();
          this.validationService.listErrors(err.data.errors);

          if (!err.data.errors || !err.data.errors.length) {
            this.Notification.error(err.data.endUserMessage);
          }
        }
      });
  }

  addCopyEmail() {
    this.settings.defaults.copy.additionalEmails.push(null);
  }

  removeCopyEmail(index) {
    this.settings.defaults.copy.additionalEmails.splice(index, 1);
  }
}

AccountSettings.$inject = ['$rootScope', '$window', '$location', 'originatorService', 'validationService', 'commonService', 'Notification'];

const accountSettings = {
  controller: AccountSettings,
  templateUrl: 'account/settings.html'
};

angular
  .module('SendRegning')
  .component('accountSettings', accountSettings)
  .config(($routeProvider) => {
    $routeProvider
      .when('/konto/innstillinger', {
        title: 'Kontoinnstillinger',
        template: '<account-settings/>',
        secure: true
      });
  });
